module.exports = __webpack_public_path__ + "static/media/flower-14.ba02f32e.svg";